document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.new-tabbed-content').forEach(function (tabSection) {
        const tabs = Array.from(
            tabSection.querySelectorAll('.filterable-slider__nav label')
        );

        if (!tabs.length) return;

        tabs.forEach(function (tab, index) {
            tab.setAttribute('tabindex', '0');

            tab.addEventListener('click', function () {
                requestAnimationFrame(function () {
                    tab.focus({ preventScroll: true });
                });
            });

            tab.addEventListener('keydown', function (e) {
                let targetIndex = index;

                if (e.key === 'ArrowRight') {
                    e.preventDefault();

                    if (index < tabs.length - 1) {
                        targetIndex = index + 1;
                    } else {
                        return;
                    }
                }

                if (e.key === 'ArrowLeft') {
                    e.preventDefault();

                    if (index > 0) {
                        targetIndex = index - 1;
                    } else {
                        return;
                    }
                }

                if (e.key === 'Home') {
                    e.preventDefault();
                    targetIndex = 0;
                }

                if (e.key === 'End') {
                    e.preventDefault();
                    targetIndex = tabs.length - 1;
                }

                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    tab.click();

                    requestAnimationFrame(function () {
                        tab.focus({ preventScroll: true });
                    });

                    return;
                }

                if (targetIndex !== index) {
                    const targetTab = tabs[targetIndex];

                    targetTab.click();

                    requestAnimationFrame(function () {
                        targetTab.focus({ preventScroll: true });
                    });
                }
            });
        });
    });

    const triggers = document.querySelectorAll('[data-image-modal-trigger]');

    triggers.forEach(function (trigger) {
        const modal = trigger.closest('.media-text').nextElementSibling;

        if (!modal || !modal.matches('[data-image-modal]')) return;

        const closeButtons = modal.querySelectorAll('[data-image-modal-close]');

        function openModal() {
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('image-modal-open');
        }

        function closeModal() {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('image-modal-open');
        }

        trigger.addEventListener('click', openModal);

        closeButtons.forEach(function (button) {
            button.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && modal.classList.contains('is-open')) {
                closeModal();
            }
        });
    });
});